"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteDisabledComponent = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const tooltip_1 = require("../tooltip/tooltip");
const tooltip_field_hook_1 = require("../tooltip/tooltip-field-hook");
const autocomplate_styles_1 = require("./autocomplate-styles");
function Row({ value }) {
    const classes = (0, autocomplate_styles_1.useStyles)();
    const { withTooltip, tooltipRef } = (0, tooltip_field_hook_1.useFieldTooltip)(value);
    const content = (react_1.default.createElement(Typography_1.default, { variant: "body1", ref: tooltipRef, className: classes.disabledComponent }, value));
    return withTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: value, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
}
function AutocompleteDisabledComponent(props) {
    var _a;
    const classes = (0, autocomplate_styles_1.useStyles)();
    const values = (_a = props.value) === null || _a === void 0 ? void 0 : _a.split('; ');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.disabledComponentWrapper }, values === null || values === void 0 ? void 0 :
            values.map((value) => (react_1.default.createElement(Row, { key: value, value: value }))),
            props.endAdornment)));
}
exports.AutocompleteDisabledComponent = AutocompleteDisabledComponent;
//# sourceMappingURL=autocomplete-disabled-component.js.map